import ErrorCode from "../../api/dtos/ErrorCode";
import { MessagesViewModel } from "../../components/bases/Messages";
import { HANDLE_ERROR, HANDLE_SUCCESS, HIDE_ALL_MESSAGES, PAGE_END_LOADING, PAGE_START_LOADING, PageActionTypes, PageState, RESET_ERROR, RESET_MESSAGE, SHOW_ERROR_MESSAGE, SHOW_INFO_MESSAGE } from "./types";

const InitialState: PageState = {
	ErrorCode: '',
	MessageCall: null,
	MessageDuration: 3000,
	IsLoading: false,
	LoadingCount: 0
};

export function GeneralAppReducer(state: PageState = InitialState, action: PageActionTypes): PageState {
	switch (action.type) {
		case HANDLE_ERROR:
			return {
				...state,
				ErrorCode: action.response.error_code as ErrorCode,
				MessageCall: (message: MessagesViewModel) => message.Error("An error happened, refresh the page"),
				MessageDuration: 3000
			}
		case HANDLE_SUCCESS:
			return {
				...state,
				MessageCall: (message: MessagesViewModel) => message.Success(action.message),
				MessageDuration: action.duration
			}
		case SHOW_INFO_MESSAGE:
			return {
				...state,
				MessageCall: (message: MessagesViewModel) => message.Info(action.message),
				MessageDuration: action.duration
			}
		case SHOW_ERROR_MESSAGE:
			return {
				...state,
				MessageCall: (message: MessagesViewModel) => message.Error(action.message),
				MessageDuration: action.duration
			}
		case HIDE_ALL_MESSAGES:
			return {
				...state,
				MessageCall: (message: MessagesViewModel) => message.CloseHandler(),
			}
		case RESET_ERROR:
			return {
				...state,
				ErrorCode: ""
			}
		case RESET_MESSAGE:
			return {
				...state,
				MessageCall: null,
			}
		case PAGE_START_LOADING:
			return {
				...state,
				LoadingCount: state.LoadingCount + 1,
				IsLoading: true
			}
		case PAGE_END_LOADING:
			let loadingCount = state.LoadingCount - 1;
			return {
				...state,
				LoadingCount: loadingCount,
				IsLoading: loadingCount > 0,
			}
		default:
			return state;
	}
}
